import { fitWithin } from '@/lib/ai-assistant/editor/frameCapture';

/** Re-encodes an image data URL as a JPEG whose long side fits `maxSide`
 *  (never upscaled). Browser only: decodes through an <img> and a canvas. */
export async function downscaleDataUrl(dataUrl: string, maxSide: number, quality: number): Promise<string> {
  const image = new Image();
  image.decoding = 'async';
  image.src = dataUrl;
  await image.decode();
  const { width, height } = fitWithin(image.naturalWidth, image.naturalHeight, maxSide);
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('no_canvas');
  context.drawImage(image, 0, 0, width, height);
  return canvas.toDataURL('image/jpeg', quality);
}
